import Typography from "../Typography/Typography"
import styles from './style.module.css'

// interface inputProp {
//     title: string
//     value: string
//     placeHolder?: string
//     disable?: boolean
//     onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
//     multiLine?: boolean
// }

interface inputProp {
  title: string
  value: string
  placeHolder?: string
  disable?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  multiLine?: boolean
}


export const InputField: React.FC<inputProp> = ({
    title,
    value,
    placeHolder,
    disable = false,
    onChange,
    multiLine = false,
}) => {
    return (
        <div className={styles.container}>

            <Typography>
                {title}
            </Typography>

            {!multiLine ? (
                <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    className={styles.input}
                    placeholder={placeHolder}
                    disabled={disable}
                />
            ) : (
                <textarea
                    value={value}
                    onChange={onChange}
                    rows={14}
                    cols={50}
                    className={`${styles.input} ${styles.textArea}`}
                // placeholder="Enter your notes here..."
                />
            )}

        </div>
    )
}